import type {Element, Root} from 'hast'
import type {Schema} from 'hast-util-sanitize'
import {visit} from 'unist-util-visit'

const keyProp = 'dataKey'

function areSameElements(a: Element, b: Element): boolean {
  if (a.tagName !== b.tagName) return false
  if (!a.properties && !b.properties) return true
  if (!a.properties || !b.properties) return false

  const aKeys = Object.keys(a.properties).filter(k => k !== keyProp)
  if (aKeys.length !== Object.keys(b.properties).filter(k => k !== keyProp).length) return false

  for (const name of aKeys) if (a.properties[name] !== b.properties[name]) return false

  return true
}

/**
 * Add a unique key to otherwise-identical adjacent element nodes so that CodeMirror won't combine their decorations.
 * It does this to optimize the DOM tree, but our nodes are semantic and combining them can break the structure (ie,
 * by merging two list items).
 */
export function hastDistinguishAdjacentElements(tree: Root): void {
  visit(tree, 'element', parent => {
    let previous: Element | null = null
    for (const node of parent.children)
      if (node.type === 'element') {
        if (previous && areSameElements(node, previous)) {
          const prevKey = typeof previous.properties?.[keyProp] === 'number' ? previous.properties[keyProp] : -1
          node.properties[keyProp] = prevKey + 1
        }
        previous = node
      }
  })
}

export const distinguishAdjacentElementsSanitizeSchema: Schema = {
  attributes: {
    ['*']: [keyProp],
  },
}
